import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { APPLY_PATH } from "@/data/content";

export const StickyApplyBar = () => {
  const { pathname } = useLocation();
  if (pathname === APPLY_PATH) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 p-3 sm:hidden" data-testid="mobile-sticky-apply">
      <Link
        to={APPLY_PATH}
        data-testid="mobile-sticky-apply-btn"
        className="btn-primary w-full shadow-[0_-8px_40px_-8px_rgba(0,252,245,0.35)]"
      >
        Apply to Become a Fleet Partner <ArrowRight size={16} />
      </Link>
    </div>
  );
};
